import * as Sentry from '@sentry/browser';
import { isDevCluster } from '../utils/labrador';
import { getLogger } from '../utils/logging';
import { getTcfConsent } from './TCFv2';
import once from '../utils/once';

const log = getLogger(`consent`);

/**
 * Ensure that we have GDPR consent. The function is omnipotent - since it's wrapped in `once` - it
 * can be called multiple times, and the same Promise will always be returned - and resolved or
 * rejected when and if the user has given or refused consent to storing cookies.
 * Singleton promise that tells whether or/when we have consent from the OneTrust consent manager.
 *
 * @return {Promise}
 */
export const hasConsent = once(async () => {
  if (isDevCluster()) {
    return [];
  }

  try {
    log.info(`Awaiting consent... `);
    await getTcfConsent().catch((err) => console.log(err));
    log.info(`Got consent...`, window.OnetrustActiveGroups);
    return [];
  } catch (err) {
    Sentry.captureMessage('Video -- Unable to retrieve tcf consent', {
      tags: {
        err,
        activeGroups:
          window && window.OnetrustActiveGroups ? JSON.stringify(window.OnetrustActiveGroups) : 'no active groups',
      },
    });
    log.info(`[ERROR]: Failed to get consent: `, err);
    throw err;
  }
});
